import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import WordDataTable from '../WordDataTable/WordDataTable'

import { makeStyles } from '@material-ui/core/styles';
  
const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(2),
    fontSize: 'small',
    color: 'white'
  },
  definition: {
    fontWeight: 'bold'
  },
  dialogRef: {
    color: 'grey',
    fontSize: '80%',
    textAlign: "center",
    marginBottom: '-15px'
  },
  dialogHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '-10px'
  },
  logo: {
    height: '30px',
    width: 'auto'
  },
  SVicons: {
    height: '50px',
    width: '50px',
    marginRight: '5px',
    marginBottom: '5px'
  },
  dialogContent: {
    display: 'flex',
    justifyContent: 'center',
    padding: '5px'
  },
  IntInfo: {
    position: 'relative',
    width: '100%',
    padding: '10px'
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  titleText: {
    flex: 6
  },
  closeButtonHolder: {
    flex: 1,
    margin: 0,
    padding: 0
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  }
}))

const InterlinearDialog = (props) => {
  const dictionary = (props.language === 'GRK' && props.version === 'GNA') ? require('../../data/strongsGreekDictionary.json') : (props.version === 'WLC') ? require('../../data/strongsHebrewDictionary.json') : null
  const classes = useStyles();
  const lexeme = (props.language === 'HBR' && props.version === 'WLC') ? props.interlinearDialog.content.HebrewLexeme : props.interlinearDialog.content.lexeme
  return (
    <Dialog 
      maxWidth='lg'
        open={props.interlinearDialog.open} 
        onClose={() => props.newInterlinearDialog({open: false, content: {}})}>
        <DialogTitle>
          <div className={classes.dialogTitle}>
            <div className={classes.titleText}>{`${lexeme} : ${(props.interlinearDialog.content.StrongNumber !== '') ? `Strong's ${(props.language === 'HBR') ? 'OT' : 'NT'} #${props.interlinearDialog.content.StrongNumber.substring(1,5)}` : `Strong's ${(props.language === 'HBR') ? 'OT' : 'NT'} #${props.interlinearDialog.content.extendedStrongNumber.substring(1,5)}`}`}</div>
            <div className={classes.closeButtonHolder}>
              <IconButton aria-label="close" className={classes.closeButton} onClick={props.onClose}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers className={classes.dialogContent}>
          <div className={classes.IntInfo}>
            <p className={classes.definition}>{`Definition: `}<em>{(dictionary[props.interlinearDialog.content.StrongNumber]) ? dictionary[props.interlinearDialog.content.StrongNumber].strongs_def : 'N/A'}</em></p>
            <WordDataTable 
              content={props.interlinearDialog.content}
              language={props.language}
              version={props.version}/>
          </div>
        </DialogContent>
      </Dialog> 
  )
}

export default InterlinearDialog;